export default "__VITE_ASSET__Dzjuol2Z__"